var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMinuteVentilation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "50px",
    height: "50px",
    viewBox: "0 0 132.685 132.714",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1384",
    "data-name": "Group 1384",
    transform: "translate(-2025.99 -733.932)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1562",
    "data-name": "Path 1562",
    d: "M2292.1,781.29a64.925,64.925,0,1,1-64.924-64.941A64.932,64.932,0,0,1,2292.1,781.29Z",
    transform: "translate(-134.839 19)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.835
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1563",
    "data-name": "Path 1563",
    d: "M2253.274,793.626l-26.153-15.808.105-20.493",
    transform: "translate(-134.832 22.35)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 2.126
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_252",
    "data-name": "Line 252",
    y2: 3.535,
    transform: "translate(2092.2 764.806)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_253",
    "data-name": "Line 253",
    x2: 3.059,
    transform: "translate(2125.116 800.736)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_254",
    "data-name": "Line 254",
    y1: 2.907,
    transform: "translate(2092.208 833.71)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_255",
    "data-name": "Line 255",
    x2: 2.884,
    transform: "translate(2056.312 800.736)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_256",
    "data-name": "Line 256",
    x1: 1.462,
    y2: 2.493,
    transform: "translate(2108.818 770.095)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_257",
    "data-name": "Line 257",
    x2: 2.862,
    y2: 1.679,
    transform: "translate(2120.457 817.269)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_258",
    "data-name": "Line 258",
    y1: 2.626,
    x2: 1.543,
    transform: "translate(2074.142 829.056)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_259",
    "data-name": "Line 259",
    x2: 2.549,
    y2: 1.496,
    transform: "translate(2061.342 782.565)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_260",
    "data-name": "Line 260",
    x1: 2.489,
    y2: 1.473,
    transform: "translate(2120.457 782.693)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_261",
    "data-name": "Line 261",
    x2: 1.568,
    y2: 2.647,
    transform: "translate(2109.127 829.103)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_262",
    "data-name": "Line 262",
    y1: 1.43,
    x2: 2.416,
    transform: "translate(2061.504 817.636)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_263",
    "data-name": "Line 263",
    x2: 1.596,
    y2: 2.696,
    transform: "translate(2074.091 769.893)",
    fill: "none",
    stroke: "#000",
    strokeLinejoin: "round",
    strokeWidth: 1.417
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_264",
    "data-name": "Line 264",
    y1: 6.519,
    transform: "translate(2092.333 755.631)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 4.948
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_265",
    "data-name": "Line 265",
    x2: 18.796,
    transform: "translate(2083.077 755.631)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.969
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1564",
    "data-name": "Path 1564",
    d: "M2259.5,775.213a38.4,38.4,0,1,1-38.4-38.409A38.4,38.4,0,0,1,2259.5,775.213Z",
    transform: "translate(-128.764 25.153)",
    fill: "none",
    stroke: "#000",
    strokeMiterlimit: 10,
    strokeWidth: 2.126
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMinuteVentilation);
export default __webpack_public_path__ + "static/media/MinuteVentilation.42e637a7.svg";
export { ForwardRef as ReactComponent };